<!--
 * @Author: redu842 2150673512@qq.com
 * @Date: 2024-05-29 14:57:25
 * @LastEditors: redu842 2150673512@qq.com
 * @LastEditTime: 2024-11-06 16:30:15
 * @FilePath: \netstorm-cloud-ui\src\views\Lightning\watch\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<!--
 * @Author: redu842 2150673512@qq.com
 * @Date: 2024-05-29 14:57:25
 * @LastEditors: redu842 2150673512@qq.com
 * @LastEditTime: 2024-05-29 16:48:32
 * @FilePath: \netstorm-cloud-ui\src\views\Lightning\watch\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="myWatcBox" id="homeMap">
    <audio id="music" src="../../assets/y2012.mp3" ref="mymusic" loop></audio>
    <div class="lendBox" v-show="isShowLend">
      <div class="lendTitle">图例</div>
      <div class="lendcolorList">
        <div class="colorItemBox" v-for="item in colorList">
          <div class="colorBox" :style="{'backgroundColor':getrgb(item)}"></div>
          <div class="textBox">{{item[0]}}</div>
        </div>
      </div>
    </div>
    <div class="showLayerchooseBox">
      <div class="showLayerchooseBoxItem" style="margin-bottom: 10px;">
        显示行政边界
        <el-switch style="margin-left:10px" @change="areaLineChange" v-model="isSHowAreaLine"></el-switch>
      </div>
      <div class="showLayerchooseBoxItem" style="margin-bottom: 10px;">
        显示网格边框
        <el-switch
          style="margin-left:10px"
          @change="ShowrcBoxlayerChange"
          v-model="isShowrcBoxlayer"
        ></el-switch>
      </div>
      <div class="showLayerchooseBoxItem" style="margin-bottom: 10px;">
        显示乡镇边界
        <el-switch style="margin-left:10px" @change="streetLineChange" v-model="isSHowstreetLine"></el-switch>
      </div>
      <div
        class="showLayerchooseBoxItem"
        style="  margin-bottom: 10px;"
        v-show="showDataType=='lightning'"
      >
        显示大气电场仪
        <el-switch style="margin-left:10px" @change="ShowmachineChange" v-model="isShowmachine"></el-switch>
      </div>
      <div class="showLayerchooseBoxItem" style="margin-bottom:10px">
        {{lintText}}
        <el-switch style="margin-left:10px" @change="ShowLightningchange" v-model="isShowLightning"></el-switch>
      </div>
      <div class="showLayerchooseBoxItem" v-show="showDataType=='Fusion'">
        警报音
        <el-switch style="margin-left:10px" @change="isOpenalarmChange" v-model="isOpenalarm"></el-switch>
      </div>
      <!-- <div class="showLayerchooseBoxItem" style="margin-top:10px" v-show="isShowLightning">
       
        <el-date-picker
          v-model="lightningTime"
          @change="getlightningData"
          size="mini"
          align="right"
          style="width:150px"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="datetime"
          placeholder="选择日期时间"
        ></el-date-picker>
      </div>-->
    </div>
    <!-- <div class="showLayerchooseBox2" v-show="showDataType=='forecast'">
      <div class="title">图层切换</div>
      <div style="margin-top:10px">
        <el-radio-group v-model="LaryerChoose" size="mini" @input="LaryerCHange">
          <el-radio label="radar">雷达</el-radio>
          <el-radio label="electric">大气电场仪</el-radio>
          <el-radio label="lightning">闪电</el-radio>
        </el-radio-group>
      </div>
    </div>-->

    <div class="controllerLeftBox">
      <!-- <div class="dataTimeBox">
        <div>预报数据时间：2024-01-01 10:44</div>
        <div>实况数据时间：2024-01-01 10:44</div>
      </div>-->
      <div class="dataTypeCHoose">
        <!-- <div
          class="dataTypeCHooseItem"
          :class="[showDataType=='forecast'?'chooseEd':'']"
          @click="mychooseDataType('forecast')"
        >预报数据</div>
        <div
          class="dataTypeCHooseItem"
          :class="[showDataType=='lightning'?'chooseEd':'']"
          @click="mychooseDataType('lightning')"
        >闪电等级</div>
        <div
          class="dataTypeCHooseItem"
          :class="[showDataType=='Fusion'?'chooseEd':'']"
          @click="mychooseDataType('Fusion')"
        >闪电等级</div>-->
        <div
          class="dataTypeCHooseItem"
          :class="[showDataType=='watch'?'chooseEd':'']"
          @click="mychooseDataType('watch')"
        >雷达监测</div>
        <div
          class="dataTypeCHooseItem"
          :class="[showDataType=='forecast'?'chooseEd':'']"
          @click="mychooseDataType('forecast')"
        >雷达外推</div>
        <div
          class="dataTypeCHooseItem"
          :class="[showDataType=='lightning'?'chooseEd':'']"
          @click="mychooseDataType('lightning')"
        >电场外推</div>
        <div
          class="dataTypeCHooseItem"
          :class="[showDataType=='Fusion'?'chooseEd':'']"
          @click="mychooseDataType('Fusion')"
        >融合结果</div>
      </div>
      <div class="leftTimeChooseBox" v-show="showDataType!='watch'">
        <div class="leftTimeChooseBoxItem">
          <div>开始时间:</div>
          <el-date-picker
            v-model="startTime"
            @change="startTimeChange"
            size="mini"
            align="right"
            value-format="yyyyMMddHHmmss"
            format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            placeholder="选择日期时间"
          ></el-date-picker>
        </div>
        <div class="leftTimeChooseBoxItem" style="margin-top:10px">
          <div>结束时间:</div>
          <el-date-picker
            v-model="endTime"
            @change="endTimeChange"
            size="mini"
            align="right"
            value-format="yyyyMMddHHmmss"
            format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            placeholder="选择日期时间"
          ></el-date-picker>
        </div>
        <div class="mytimeChooseBox">
          <div class="btn" @click="subTime">上个时次</div>
          <div class="btn" @click="addTime">下个时次</div>
        </div>
        <el-button
          type="primary"
          size="mini"
          style="width:100%;margin-top:10px"
          @click="timeChange"
        >查询</el-button>
      </div>
    </div>
    <div class="timeLineBox" v-show="isSHowTimeLine">
      <div class="timeLineBoxInbox">
        <div class="playBtn" @click="palyHander">
          <img src="../../assets/paly.png" v-show="!isplaying" style="width:30px;height:30px" alt />
          <img src="../../assets/stop.png" v-show="isplaying" style="width:30px;height:30px" alt />
        </div>
        <div class="timeline">
          <el-slider
            v-model="timeLineData"
            show-stops
            :marks="marks"
            @change="changeMapGrid"
            :min="slidMindata"
            :max="slidMaxdata"
          ></el-slider>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { getGridData } from "@/api/lightning/watch.js";
// import { listLightning } from "@/api/analyse/lightning";
import ligthing from "../../assets/ligthing.png";
import sensor32 from "../../assets/sensor32.png";
import moment from "moment";
import shongjiangJson from "../../map/310117-松江区";
import shongjiangstreeJson from "../../map/310117.json";
import { MapCreate, legendColor } from "../../map/mapImport";
// import axios from "axios";
export default {
  data() {
    return {
      isShowrcBoxlayer: true,
      funsionfTim: 6,
      FusionLintingData: [],
      arrLength: 19,
      waringleavelList: [
        {
          num: 0,
          color: "#e6c700",
          text: "无"
        },
        {
          num: 1,
          color: "#e6c700",
          text: "黄色"
        },
        {
          num: 2,
          color: "#e67b00",
          text: "橙色"
        },
        {
          num: 3,
          color: "#e62600",
          text: "红色"
        }
      ],
      lintText: "显示实时闪电",
      isOpenalarm: false,
      imgLayer: null,
      isSHowstreetLine: true,
      streetNameLayer: null,
      streetLayer: null,
      startTime: "",
      endTime: "",
      machineLayer: null,
      isShowmachine: false,
      lightningTime: "",
      isShowLightning: false,
      showDataType: "forecast",
      isSHowTimeLine: true,
      isShowLend: true,
      sldPlayTimeer: null,
      LaryerChoose: "radar",
      // mapSHowTYpe: "Administrative",
      isSHowAreaLine: true,
      tilePixelLayer: null,
      makerLayer: null,
      tableData: [],
      colorList: legendColor["radar"],
      radio1: "实况数据",
      map: null,
      isplaying: false,
      slidMindata: 0,
      slidMaxdata: 19,
      timeLineData: 0,
      marks: {
        0: "0°C",
        8: "8°C",
        37: "37°C",
        50: {
          style: {
            color: "#1989FA"
          },
          label: this.$createElement("strong", "50%")
        }
      },
      areaLayer: null,
      gridDataList: [],
      chooseGridData: null,
      girdColor: "#636363"
    };
  },
  mounted() {
    this.map = new MapCreate();
    this.map.init("homeMap");
    this.map.map.on("baselayerchange", e => {
      if (this.LaryerChoose != "radar") {
        if (e.name.search("行政图") != -1) {
          this.girdColor = "#636363";
          // console.log("行政图");
        } else if (e.name.search("卫星图") != -1) {
          this.girdColor = "white";
          // console.log("卫星图");
        } else if (e.name.search("地形图") != -1) {
          // console.log("地形图");
          this.girdColor = "#276363";
        }
        this.addMakerToMap();
      }
    });
    let t = this;
    let mymakerList = [];
    const style2 = {
      color: "#01203f", //线颜色
      weight: 2, //线粗细
      opacity: 1, //透明度
      fillColor: "#fff", //区域填充颜色
      fillOpacity: 0 //区域填充颜色的透明
    };
    this.streetLayer = L.geoJSON(shongjiangstreeJson.features, {
      style: style2,
      onEachFeature: function(feature, layer) {
        let print = t.getPolygon(feature.geometry.coordinates[0][0]);
        // //console.log(print);
        let myIcon = L.divIcon({
          html: `<div class="myareaNameBox" style="font-size: 12px;
    color:white;text-align:center;font-weight: 600; background-color: #01203f7e;
    ">${feature.properties.name}</div>`,
          className: "my-div-icon",
          iconSize: [80, 10]
        });
        let mymarker = L.marker(print, {
          zIndexOffset: 1000,
          icon: myIcon
        });
        mymakerList.push(mymarker);
        // //console.log(mymarker);
      }
    }).addTo(this.map.map);
    this.streetNameLayer = L.layerGroup(mymakerList).addTo(this.map.map);
    const style = {
      color: "red", //线颜色
      weight: 4, //线粗细
      opacity: 1, //透明度
      fillColor: "#fff", //区域填充颜色
      fillOpacity: 0 //区域填充颜色的透明
    };
    this.areaLayer = L.geoJSON(shongjiangJson.features, { style: style }).addTo(
      this.map.map
    );
    this.map.map.fitBounds(this.areaLayer.getBounds());
    // this.getlineMarker();
  },
  created() {
    this.lightningTime = moment().format("YYYY-MM-DD 00:00:00");
    this.startTime = moment()
      .subtract(10, "m")
      .format("YYYYMMDDHHmm00");
    this.endTime = moment().format("YYYYMMDDHHmm00");
    // this.startTime = "20240719154000";
    // this.endTime = "20240719155000";
    this.getlineMarker(this.startTime, 10);
    this.getData("radar");
    // this.getFusionData();
    // this.mychooseDataType("Fusion");
  },
  beforeDestroy() {
    this.map.map.remove();
  },
  methods: {
    startTimeChange(e) {
      console.log(e);
      this.endTime = moment(e, "YYYYMMDDHHmmss")
        .add(10, "m")
        .format("YYYYMMDDHHmm00");
    },
    endTimeChange(e) {
      this.startTime = moment(e, "YYYYMMDDHHmmss")
        .subtract(10, "m")
        .format("YYYYMMDDHHmm00");
    },
    addTime() {
      this.startTime = moment(this.startTime, "YYYYMMDDHHmmss")
        .add(10, "m")
        .format("YYYYMMDDHHmm00");
      this.endTime = moment(this.endTime, "YYYYMMDDHHmmss")
        .add(10, "m")
        .format("YYYYMMDDHHmm00");
    },
    subTime() {
      this.startTime = moment(this.startTime, "YYYYMMDDHHmmss")
        .subtract(10, "m")
        .format("YYYYMMDDHHmm00");
      this.endTime = moment(this.endTime, "YYYYMMDDHHmmss")
        .subtract(10, "m")
        .format("YYYYMMDDHHmm00");
    },
    getColor(data) {
      if (data == null) {
        return "";
      } else {
        let waringleavelList = this.waringleavelList;
        let myLeavel = waringleavelList.filter(el => {
          return el.num == data;
        });
        // console.log(myLeavel);
        return myLeavel[0].color;
      }
    },
    getText(data) {
      console.log(data);
      if (data == null) {
        return "";
      } else {
        let waringleavelList = this.waringleavelList;
        let myLeavel = waringleavelList.filter(el => {
          return el.num == data;
        });
        console.log(myLeavel);
        return myLeavel[0].text;
      }
    },
    isOpenalarmChange(e) {
      let audio = this.$refs.mymusic;
      // this.isFirstPlay = !this.isFirstPlay;

      if (e) {
        audio.play();
      } else {
        audio.pause();
      }
    },
    changeImgLayer() {
      if (this.imgLayer != null) {
        let oldtilePixelLayer = this.imgLayer;
        //console.log(oldtilePixelLayer.getElement());
        oldtilePixelLayer.getElement().classList.add("MyImghidden");
        setTimeout(() => {
          this.map.map.removeLayer(oldtilePixelLayer);
        }, 2000);
      }
      let imageBounds = [
        [54.17858733586307, 72.99565959351648],
        [12.149628914526106, 135.48483558454907]
      ];

      this.imgLayer = L.imageOverlay(this.chooseGridData.data, imageBounds, {
        opacity: 0.7
      }).addTo(this.map.map);
    },
    showImgToMap() {
      this.$axios({
        method: "get",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        url: `https://www.91weather.com/scattered/imminent/alarm?type=2`
      }).then(res => {
        console.log(res.data.detail.series);
        let imglist = [];
        let imgobj = res.data.detail.series;
        // let mymarkerobj = {};
        for (const key in imgobj) {
          if (Object.hasOwnProperty.call(imgobj, key)) {
            const element = imgobj[key];
            //console.log(element, key);

            imglist.push({
              name: key,
              data: `http://cdn-repo.cn-bj.ufileos.com/${element}`
            });
          }
        }

        let newimglist = imglist.sort((a, b) => {
          return a.name - b.name;
        });
        // console.log(newimglist);
        let imageBounds = [
          [54.17858733586307, 72.99565959351648],
          [12.149628914526106, 135.48483558454907]
        ];
        this.gridDataList = newimglist;
        this.getlineMarker(newimglist[0].name, newimglist.length);
        this.imgLayer = L.imageOverlay(newimglist[0].data, imageBounds, {
          opacity: 0.7
        }).addTo(this.map.map);
      });
    },
    streetLineChange(e) {
      if (e) {
        let t = this;
        let mymakerList = [];
        const style2 = {
          color: "#01203f", //线颜色
          weight: 2, //线粗细
          opacity: 1, //透明度
          fillColor: "#fff", //区域填充颜色
          fillOpacity: 0 //区域填充颜色的透明
        };
        this.streetLayer = L.geoJSON(shongjiangstreeJson.features, {
          style: style2,
          onEachFeature: function(feature, layer) {
            let print = t.getPolygon(feature.geometry.coordinates[0][0]);
            // //console.log(print);
            let myIcon = L.divIcon({
              html: `<div class="myareaNameBox" style="font-size: 12px;
    color:white;text-align:center;font-weight: 600; background-color: #01203f7e;
    ">${feature.properties.name}</div>`,
              className: "my-div-icon",
              iconSize: [80, 10]
            });
            let mymarker = L.marker(print, {
              zIndexOffset: 1000,
              icon: myIcon
            });
            mymakerList.push(mymarker);
            // //console.log(mymarker);
          }
        }).addTo(this.map.map);
        this.streetNameLayer = L.layerGroup(mymakerList).addTo(this.map.map);
      } else {
        if (this.streetLayer != null) {
          this.map.map.removeLayer(this.streetLayer);
          this.streetLayer = null;
        }
        if (this.streetNameLayer != null) {
          this.map.map.removeLayer(this.streetNameLayer);
          this.streetNameLayer = null;
        }
      }
    },
    ShowmachineChange(e) {
      if (this.machineLayer != null) {
        this.map.map.removeLayer(this.machineLayer);
        this.machineLayer = null;
      }
      if (e) {
        this.$axios({
          method: "post",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          },
          // url: `${this.$url}?interfaceId=getDqdcyBytime&starttime=2023-11-30%2007:43:44&endtime=2023-11-30%2007:49:44`
          url: `${
            this.$url
          }?interfaceId=getDqdcyBytime&starttime=${moment().format(
            "YYYY-MM-DD 00:00:00"
          )}&endtime=${moment().format("YYYY-MM-DD HH:mm:ss")}`
        }).then(res => {
          // console.log(res.data.dataList);
          if (res.data.dataList.length == 0) {
            this.$message("无数据");
            return;
          }
          let greenIcon = L.icon({
            iconUrl: sensor32,
            iconSize: [32, 32] // size of the icon
          });
          let markerList = [];
          res.data.dataList.map(item => {
            markerList.push(
              L.marker([item.Lat, item.Lon], {
                icon: greenIcon
              }).bindPopup(`
            <div>时间：${moment(item.dateTime).format(
              "YYYY-MM-DD HH:mm:ss"
            )}</div>
            <div>站名：${item.deviceName}</div>
            <div>编号：${item.deviceId}</div>
            <div>经度：${item.Lon}</div>
            <div>纬度：${item.Lat}</div>
            <div>数值：${item.obsVal}</div>
           
            `)
            );
          });
          this.machineLayer = L.layerGroup(markerList).addTo(this.map.map);
        });
      }
    },
    getFusionData() {
      console.log("fusion");
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      this.$axios({
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        url: `${this.$url}?interfaceId=getGridRadarLevelByTime&starttime=${this.startTime}&endtime=${this.endTime}`
        // url: `${this.$url}?interfaceId=getGridRadarLevel`
      }).then(res => {
        if (res.data.dataList.length == 0) {
          this.$message("当前时间无数据");

          return;
        }

        console.log(res);
        this.funsionfTime = res.data.dataList[0].fTime;
        // console.log(res.data.dataList);
        this.gridDataList = res.data.dataList.slice(0, 10);
        this.chooseGridData = res.data.dataList[0];
        this.getlineMarker(
          res.data.dataList[0].dTime,
          res.data.dataList.slice(0, 10).length
        );
        this.addMakerToMap();
        // let ledcolorList = JSON.parse(
        //   JSON.stringify(legendColor[this.LaryerChoose])
        // );
        // console.log(ledcolorList);
        // let dataList = res.data.dataList[this.timeLineData].datas
        //   .split(",")
        //   .map(item => {
        //     if (item != 0) {
        //       console.log(item);
        //     }
        //     return Number(item);
        //   });
        // console.log(dataList);

        // this.gridDataList = res.data.dataList;
        // this.tilePixelLayer = L.tilePixelLayer({
        //   newData: dataList,
        //   data: res.data.dataList[0],
        //   gradient: ledcolorList
        // });
        // this.map.map.addLayer(this.tilePixelLayer);
        loading.close();

        // console.log(res);
      });
    },
    ShowrcBoxlayerChange(e) {
      this.addMakerToMap();
    },
    addMakerToMap() {
      let rcoption = 1;
      if (this.isShowrcBoxlayer) {
        rcoption = 1;
      } else {
        rcoption = 0;
      }
      let ledcolorList = JSON.parse(
        JSON.stringify(legendColor[this.LaryerChoose])
      );
      console.log(ledcolorList);
      let data = this.chooseGridData;
      if (this.textmarkerLayer != null) {
        this.map.map.removeLayer(this.textmarkerLayer);
        this.textmarkerLayer = null;
      }
      let xySum = 1;
      let dataList = [];
      // if (this.checkList == "大风") {
      //   dataList = data.windS.map(item => {
      //     return Number(item);
      //   });
      //   xySum = 1;
      // } else if (this.checkList == "雷达") {
      //   dataList = data.datas.map(item => {
      //     return Number(item);
      //   });
      //   xySum = 10;
      // } else {
      dataList = data.datas.split(",").map(item => {
        return Number(item);
      });
      //   xySum = 1;
      // }
      console.log(dataList);
      let index = 0;
      let xq = (data.right - data.left) / data.cols;
      let yq = (data.top - data.bottom) / data.rows;
      let makerList = [];
      for (let i = 0; i < data.rows; i += xySum) {
        for (let k = 0; k < data.cols; k += xySum) {
          let markerIcon = L.divIcon({
            html: `<div class="maerktext" style="color:${this.girdColor}">${dataList[index]}</div>`, //marker标注
            className: "my-div-icon",
            iconSize: [20, 10], //marker宽高
            iconAnchor: [10, 5] //文字标注相对位置
          });
          let color = [0, [255, 255, 255, 0]];
          if (dataList[index] > 0) {
            // console.log(dataList[index]);
            // console.log(dataList[index]);
            ledcolorList.map((item, idnex2) => {
              // if()
              // console.log(ledcolorList[idnex2 + 1]);
              if (ledcolorList[idnex2 + 1] != undefined) {
                if (
                  item[0] <= dataList[index] &&
                  ledcolorList[idnex2 + 1][0] > dataList[index]
                ) {
                  color = item;
                }
              } else {
                if (item[0] <= dataList[index]) {
                  color = item;
                }
              }
            });
          }

          let lonLine = L.rectangle(
            [
              [data.top - yq * i, data.left + xq * k],
              [data.top - yq * (i + 1), data.left + xq * (k + 1)]
            ],
            {
              weight: 1,
              fillColor: `rgb(${color[1][0]}, ${color[1][1]}, ${color[1][2]})`,
              color: this.girdColor,
              fillOpacity: color[1][3],
              opacity: rcoption,
              className: "dashLine"
            }
          );
          // if (this.isShowrcBoxlayer) {
          makerList.push(lonLine);
          // }

          index++;
          makerList.push(
            L.marker(
              [data.top - yq * i - yq / 2, data.left + xq * k + xq / 2],
              {
                icon: markerIcon
              }
            )
          );
        }
      }
      this.textmarkerLayer = L.layerGroup(makerList).addTo(this.map.map);
    },
    ShowLightningchange(e) {
      if (e) {
        if (this.showDataType == "Fusion") {
          this.getFusionlightningData();
        } else {
          this.getlightningData();
        }
      } else {
        if (this.makerLayer != null) {
          this.map.map.removeLayer(this.makerLayer);
          this.makerLayer = null;
        }
      }
    },
    getlightningLavlel() {
      // getGridData({
      //   interfaceId: "getGridRadarLevel"
      // }).then(res => {
      //   console.log(res);
      // });
    },
    timeChange() {
      // console.log(moment(this.endTime,'YYYYMMDDHH0000').diff(moment(this.startTime,'YYYYMMDDHH0000'), "seconds"));

      this.mychooseDataType(this.showDataType);
    },
    mychooseDataType(e) {
      // console.log(2121212);
      this.isShowLightning = false;
      this.ShowLightningchange(false);
      this.lintText = "显示实时闪电";
      this.showDataType = e;
      if (this.imgLayer != null) {
        this.map.map.removeLayer(this.imgLayer);
        this.imgLayer = null;
      }
      if (this.tilePixelLayer != null) {
        this.map.map.removeLayer(this.tilePixelLayer);
        this.tilePixelLayer = null;
      }
      if (this.textmarkerLayer != null) {
        this.map.map.removeLayer(this.textmarkerLayer);
        this.textmarkerLayer = null;
      }
      this.isShowmachine = false;
      this.ShowmachineChange(this.isShowmachine);
      if (this.isplaying) {
        this.palyHander();
      }
      this.timeLineData = 0;
      if (e == "forecast") {
        this.getData("radar");
        this.LaryerChoose = "radar";
      } else if (e == "lightning") {
        // this.getlightningLavlel();
        this.LaryerChoose = "electric";
        this.getData("dqdcy");
      } else if (e == "Fusion") {
        this.LaryerChoose = "fusion";
        this.getFusionData();
        this.isShowLightning = true;
        this.ShowLightningchange(true);
        this.lintText = "显示预测闪电";
      } else if (e == "watch") {
        this.LaryerChoose = "watch";
        // this.LaryerChoose = "radar";
        this.showImgToMap();
      }
      this.colorList = legendColor[this.LaryerChoose];
      // console.log(this.LaryerChoose);
    },
    // palyHander() {
    //   this.isplaying = !this.isplaying;
    //   if (this.isplaying) {
    //     if (this.LaryerChoose == "radar") {
    //       this.sldPlayTimeer = setInterval(() => {
    //         if (this.timeLineData == 19) {
    //           this.timeLineData = 0;
    //         } else {
    //           this.timeLineData = this.timeLineData + 1;
    //         }

    //         this.changeMapGrid();
    //       }, 1000);
    //     } else {
    //       this.sldPlayTimeer = setInterval(() => {
    //         if (this.timeLineData == 19) {
    //           this.timeLineData = 0;
    //         } else {
    //           this.timeLineData = this.timeLineData + 1;
    //         }

    //         // this.changeMapGrid();
    //         this.chooseGridData = this.gridDataList[this.timeLineData];
    //         this.addMakerToMap();
    //       }, 1000);
    //     }
    //   } else {
    //     clearInterval(this.sldPlayTimeer);
    //     this.sldPlayTimeer = null;
    //   }
    // },
    palyHander() {
      this.isplaying = !this.isplaying;
      if (this.isplaying) {
        this.sldPlayTimeer = setInterval(() => {
          if (this.timeLineData == this.arrLength) {
            this.timeLineData = 0;
          } else {
            this.timeLineData = this.timeLineData + 1;
          }

          // this.changeMapGrid();
          if (this.gridDataList[this.timeLineData] == undefined) return;
          this.chooseGridData = this.gridDataList[this.timeLineData];

          // console.log(this.LaryerChoose);
          if (this.LaryerChoose == "watch") {
            this.changeImgLayer();
          } else {
            if (this.LaryerChoose == "fusion") {
              // console.log(21212121);
              this.funsionfTim = this.chooseGridData.fTime;
              this.showFusionLit();
            }
            this.addMakerToMap();
          }
        }, 1000);
      } else {
        clearInterval(this.sldPlayTimeer);
        this.sldPlayTimeer = null;
      }
    },
    changeMapGrid222() {
      let ledcolorList = JSON.parse(
        JSON.stringify(legendColor[this.LaryerChoose])
      );
      let dataList = [];
      if (this.showDataType == "Fusion") {
        dataList = this.gridDataList[this.timeLineData].datas
          .split(",")
          .map(item => {
            return Number(item);
          });
      } else {
        dataList = this.gridDataList[this.timeLineData].datas
          .split(", ")
          .map(item => {
            return Number(item);
          });
      }

      // console.log(dataList);
      let oldTitle = this.tilePixelLayer;
      // ////console.log(dataList);
      this.tilePixelLayer = L.tilePixelLayer({
        newData: dataList,
        data: this.gridDataList[this.timeLineData],
        gradient: ledcolorList
      });
      // this.map.map.on("layeradd", () => {
      //   console.log("layeradd");
      //   this.map.map.removeLayer(oldTitle);
      // });
      this.map.map.addLayer(this.tilePixelLayer);
      setTimeout(() => {
        this.map.map.removeLayer(oldTitle);
      }, 500);
    },
    changeMapGrid() {
      this.chooseGridData = this.gridDataList[this.timeLineData];
      if (this.LaryerChoose == "watch") {
        this.changeImgLayer();
      } else {
        // console.log(this.LaryerChoose);
        if (this.LaryerChoose == "fusion") {
          // console.log(21212121);
          this.funsionfTim = this.chooseGridData.fTime;
          this.showFusionLit();
        }
        // this.chooseGridData = this.gridDataList[this.timeLineData];
        this.addMakerToMap();
      }
    },
    getPolygon(pList) {
      var area = 0;
      var x = 0;
      var y = 0;
      for (var i = 1; i <= pList.length; i++) {
        var lat = pList[i % pList.length][0];
        var lng = pList[i % pList.length][1];
        var nextLat = pList[i - 1][0];
        var nextLng = pList[i - 1][1];
        var temp = (lat * nextLng - lng * nextLat) / 2;
        area += temp;
        x += (temp * (lat + nextLat)) / 3;
        y += (temp * (lng + nextLng)) / 3;
      }
      x = x / area;
      y = y / area;
      return [y, x];
    },
    areaLineChange(e) {
      // console.log(e);
      if (e) {
        const style = {
          color: "red", //线颜色
          weight: 4, //线粗细
          opacity: 1, //透明度
          fillColor: "#fff", //区域填充颜色
          fillOpacity: 0 //区域填充颜色的透明
        };
        this.areaLayer = L.geoJSON(shongjiangJson.features, {
          style: style
        }).addTo(this.map.map);
      } else {
        if (this.areaLayer != null) {
          this.map.map.removeLayer(this.areaLayer);
          this.areaLayer = null;
        }
      }
    },
    // LaryerCHange(e) {
    //   this.colorList = legendColor[this.LaryerChoose];
    //   if (this.tilePixelLayer != null) {
    //     this.map.map.removeLayer(this.tilePixelLayer);
    //     this.tilePixelLayer = null;
    //   }
    //   if (this.makerLayer != null) {
    //     this.map.map.removeLayer(this.makerLayer);
    //     this.makerLayer = null;
    //   }
    //   this.timeLineData = 0;
    //   if (this.isplaying) {
    //     this.palyHander();
    //   }
    //   this.isSHowTimeLine = true;
    //   this.isShowLend = true;
    //   if (e == "radar") {
    //     this.getData("radar");
    //   } else if (e == "electric") {
    //     this.getData("dqdcy");
    //   } else {
    //     this.getlightningData();
    //     this.isSHowTimeLine = false;
    //     this.isShowLend = false;
    //   }
    // },
    getlightningData() {
      if (this.makerLayer != null) {
        this.map.map.removeLayer(this.makerLayer);
        this.makerLayer = null;
      }
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      this.$axios({
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        url: `
        ${this.$url}?interfaceId=getLightBytime&starttime=${moment(
          this.startTime,
          "YYYYMMDDHHmmss"
        ).format("YYYY-MM-DD HH:mm:ss")}&endtime=${moment(
          this.endTime,
          "YYYYMMDDHHmmss"
        ).format("YYYY-MM-DD HH:mm:ss")}`
      }).then(res => {
        // console.log(res);
        loading.close();
        // console.log(res.rows);
        //     if (this.windspeedLayer) {
        //   this.map.map.removeLayer(this.windspeedLayer);
        //   this.windspeedLayer = null;
        // }
        if (res.data.dataList.length == 0) {
          this.$message("当前无闪电发生");

          return;
        }
        let greenIcon = L.icon({
          iconUrl: ligthing,
          iconSize: [20, 20] // size of the icon
        });
        let markerList = [];
        res.data.dataList.map(item => {
          // console.log(item);
          markerList.push(
            L.marker([item.lat, item.lon], {
              icon: greenIcon
            }).bindPopup(`
            <div>时间：${moment(item.datetime).format(
              "YYYY-MM-DD HH:mm:ss"
            )}</div>
            <div>经度：${item.lon}</div>
            <div>纬度：${item.lat}</div>
            <div>强度：${item.strong}</div>
            <div>陡度：${item.distance}</div>
            `)
          );
        });
        this.makerLayer = L.layerGroup(markerList).addTo(this.map.map);
      });
    },
    getFusionlightningData() {
      if (this.makerLayer != null) {
        this.map.map.removeLayer(this.makerLayer);
        this.makerLayer = null;
      }
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      this.$axios({
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        // url: `${this.$url}?interfaceId=getLdWarninfoBytimes&starttime=20240710210000&endtime=20240711212800`
        url: `${this.$url}?interfaceId=getLdWarninfoBytimes&starttime=${this.startTime}&endtime=${this.endTime}`
        // url: `${this.$url}?interfaceId=getLdWarninfoBytime`
      }).then(res => {
        console.log(res.data.dataList);
        loading.close();
        // console.log(res.rows);
        //     if (this.windspeedLayer) {
        //   this.map.map.removeLayer(this.windspeedLayer);
        //   this.windspeedLayer = null;
        // }
        if (res.data.dataList.length == 0) {
          this.$message("无预测闪电");

          return;
        }
        this.FusionLintingData = res.data.dataList;
        this.showFusionLit();
      });
    },
    showFusionLit() {
      console.log(this.funsionfTim);
      if (this.makerLayer != null) {
        this.map.map.removeLayer(this.makerLayer);
        this.makerLayer = null;
      }
      let greenIcon = L.icon({
        iconUrl: ligthing,
        iconSize: [20, 20] // size of the icon
      });
      let markerList = [];
      let waringleavelList = this.waringleavelList;
      this.FusionLintingData.map(item => {
        // console.log(item);
        if (item.fTime == this.funsionfTim) {
          // let myLeavel = waringleavelList.filter(el => {
          //   return el.num == item.level;
          // });
          // console.log();
          let t = this;
          // console.log(t.getText(item.level));
          markerList.push(
            L.marker([item.lat, item.lon], {
              icon: greenIcon
            }).bindPopup(`
            <div style="font-size:16px;margin-top:10px">时间：${moment(
              item.dTime,
              "YYYYMMDDHHmmss"
            ).format("YYYY-MM-DD HH:mm:ss")}</div>
            <div style="font-size:16px;margin-top:10px">经度：${item.lon}</div>
            <div style="font-size:16px;margin-top:10px">纬度：${item.lat}</div>
            <div style="font-size:16px;margin-top:10px">预警级别(3km)：${t.getText(
              item.level
            )}预警</div>
            <div style="font-size:16px;margin-top:10px">预警级别(6km)：${t.getText(
              item.level12
            )}预警</div>
            <div style="font-size:16px;margin-top:10px">预警级别(9km)：${t.getText(
              item.level18
            )}预警</div>
          
            <div style="font-size:16px;margin-top:10px">预测时效：${
              item.Timeliness
            }分钟</div>
          
            `)
          );
        }
      });
      console.log(markerList);
      this.makerLayer = L.layerGroup(markerList).addTo(this.map.map);
    },
    getData(data) {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      this.$axios({
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        url: `${this.$url}?interfaceId=getGridRadarBytbTime&Level=${data}&starttime=${this.startTime}&endtime=${this.endTime}`
        // url: `${this.$url}?interfaceId=getGridRadarBytablename&Level=${data}`
      }).then(res => {
        loading.close();
        // console.log(res.data.dataList);
        if (res.data.dataList.length == 0) {
          this.$message("当前时间无数据");

          return;
        }
        this.getlineMarker(
          res.data.dataList[0].dTime,
          res.data.dataList.slice(0, 10).length
        );
        // return;
        // if (data == "dqdcy") {
        this.gridDataList = res.data.dataList.slice(0, 10);
        this.chooseGridData = res.data.dataList[0];
        this.addMakerToMap();
        // } else {
        //   let ledcolorList = JSON.parse(
        //     JSON.stringify(legendColor[this.LaryerChoose])
        //   );
        //   console.log(ledcolorList);
        //   let dataList = res.data.dataList[this.timeLineData].datas
        //     .split(", ")
        //     .map(item => {
        //       return Number(item);
        //     });
        //   console.log(dataList);

        //   this.gridDataList = res.data.dataList;
        //   this.tilePixelLayer = L.tilePixelLayer({
        //     newData: dataList,
        //     data: res.data.dataList[0],
        //     gradient: ledcolorList
        //   });
        //   this.map.map.addLayer(this.tilePixelLayer);
        // }
      });
    },
    getrgb(data) {
      //// ////console.log(data);
      //// ////console.log(`rgb(${data[1][0]},${data[1][1]},${data[1][2]})`);
      return `rgb(${data[1][0]},${data[1][1]},${data[1][2]})`;
    },

    getlineMarker(time, len) {
      this.arrLength = len;
      this.slidMaxdata = len;
      let newdate = moment(time, "YYYYMMDDHHmmss").format("HH:mm");
      // ////console.log(newdate);
      let marker = {};
      for (let i = 0; i <= len; i++) {
        //// ////console.log(i);
        if (i % 2 == 0) {
          marker[i] = {
            style: {
              color: "white"
            },
            label: moment(newdate, "HH:mm")
              .add(i * 6, "m")
              .format("HH:mm")
          };
        }
      }
      // ////console.log(marker);
      this.marks = marker;
    }
  }
};
</script>

<style>
.myWatcBox {
  width: 100%;
  /* height: 100%; */
  min-height: calc(100vh - 84px);
  /* background-color: aqua; */
}
.timeLineBox {
  height: 60px;
  width: 60vw;
  background-color: #011f3d;
  position: absolute;
  bottom: 5px;
  left: 20vw;
  z-index: 999;
  border-radius: 15px;
  /* display: flex;
  justify-content: space-around;
  align-items: center; */
  /* padding: 0 5px; */
}
.timeLineBoxInbox {
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 60px;
  width: 60vw;
}
.timeline {
  height: 100%;
  width: 90%;
  padding-right: 10px;
  /* position: relative;
  top: 5px; */
}
.playBtn {
  height: 100%;
  width: 5%;
  /* background-color: #8c6e14; */
  /* text-align: center; */
  display: flex;
  align-items: center;
  justify-content: center;
}
.maerktext {
  font-size: 7px;
  /* color: #02203c; */
  font-weight: 600;
  /* border: 1px solid white; */
  text-align: center;

  /* width: 10px;
  height: 10px; */
  /* background-color: #00bfff; */
}
.controllerBox {
  height: 500px;
  width: 610px;
  /* background-color: aqua; */
  position: absolute;
  right: 10px;
  top: 250px;
  z-index: 999;
  display: flex;
  /* justify-content: space-between; */
  /* justify-items: end; */
  justify-content: flex-end;
}
.tableBox {
  height: 500px;
  width: 300px;
  /* background-color: antiquewhite; */
}
.tableBox2 {
  height: 500px;
  width: 300px;
  background-color: #011f3dcb;
  overflow: hidden;
  border: 1px solid #079dd5;
  box-shadow: 0 0 5px rgba(0, 191, 255, 0.5), 0 0 10px rgba(0, 191, 255, 0.3),
    0 0 15px rgba(0, 191, 255, 0.2);
}
.tableBoxItem {
  height: 245px;
  width: 100%;
  background-color: #011f3dcb;
  overflow: hidden;
  border: 1px solid #079dd5;
  box-shadow: 0 0 5px rgba(0, 191, 255, 0.5), 0 0 10px rgba(0, 191, 255, 0.3),
    0 0 15px rgba(0, 191, 255, 0.2);
}
.tableTitleBox {
  height: 30px;
  width: 100%;
  background-color: #011f3d;
  color: #00bfff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 5px;
  font-family: Cambria, Cochin, Georgia, Times, "Times New Roman", serif;
}
.showLayerchooseBox {
  /* height: 50px; */
  /* width: 100px; */
  background-color: #011f3dcb;
  position: absolute;
  top: 80px;
  right: 10px;
  z-index: 999;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #079dd5;
  box-shadow: 0 0 5px rgba(0, 191, 255, 0.5), 0 0 10px rgba(0, 191, 255, 0.3),
    0 0 15px rgba(0, 191, 255, 0.2);
  color: #00bfff;
}
.showLayerchooseBox2 {
  /* height: 50px; */
  /* width: 200px; */
  background-color: #011f3dcb;
  position: absolute;
  top: 150px;
  right: 10px;
  z-index: 999;
  padding: 0px 10px 5px 10px;
  border-radius: 5px;
  border: 1px solid #079dd5;
  box-shadow: 0 0 5px rgba(0, 191, 255, 0.5), 0 0 10px rgba(0, 191, 255, 0.3),
    0 0 15px rgba(0, 191, 255, 0.2);
  color: #00bfff;
}
.showLayerchooseBox2 .title {
  width: 100%;
  height: 30px;
  text-align: center;
  line-height: 30px;
  font-size: 16px;
  font-family: Cambria, Cochin, Georgia, Times, "Times New Roman", serif;
}
.controllerLeftBox {
  height: 200px;
  width: 250px;
  /* background-color: aqua; */
  /* border: 1px solid red; */
  position: absolute;
  left: 10px;
  top: 20px;
  z-index: 999;
}
.dataTimeBox {
  /* height: 50px; */
  width: 100%;
  background-color: #01203f;
  padding: 5px 10px;
  line-height: 20px;
  color: white;
  /* font-weight: 600; */
  border-radius: 5px;
  border: 1px solid #079dd5;
  box-shadow: 0 0 5px rgba(0, 191, 255, 0.5), 0 0 10px rgba(0, 191, 255, 0.3),
    0 0 15px rgba(0, 191, 255, 0.2);
  color: #00bfff;
  font-family: "Orbitron", sans-serif;
}
.dataTypeCHoose {
  margin-top: 15px;
  width: 100%;
  /* background-color: #00bfff; */
  background-color: #01203f;
  border-radius: 5px;
  overflow: hidden;
  display: flex;
  border: 1px solid #079dd5;
}
.dataTypeCHooseItem {
  width: 50%;
  height: 30px;
  /* background-color: #01203f; */
  text-align: center;
  line-height: 30px;
  color: white;
}
.chooseEd {
  background-color: #496285;
  font-weight: 600;
  font-size: 14px;
}

/* .el-radio__label {
  color: rgb(255, 255, 255) !important;
} */
/* .el-table,
.el-table__expanded-cell {
  background-color: transparent !important;
}

.el-table th,
.el-table tr,
.el-table td {
  background-color: transparent !important;
  color: white;
} */
.lendBox {
  /* height: 300px; */
  width: 100px;
  position: absolute;
  bottom: 5px;
  left: 10px;
  background-color: #011f3dcb;
  z-index: 999;
  border-radius: 10px;
  box-shadow: 0 0 5px rgba(0, 191, 255, 0.5), 0 0 10px rgba(0, 191, 255, 0.3),
    0 0 15px rgba(0, 191, 255, 0.2);
}
.lendTitle {
  height: 30px;
  width: 100%;
  text-align: center;
  line-height: 30px;
  color: white;
  font-size: 16px;
}
.lendcolorList {
  width: 100%;
  padding: 10px;
}
.colorItemBox {
  height: 15px;
  width: 100%;
  /* background-color: red; */
  display: flex;
  justify-content: space-between;
  margin-top: 5px;
  border-bottom: 1px solid white;
}
.colorBox {
  height: 15px;
  width: 40%;
  background-color: #00bfff;
}
.textBox {
  height: 15px;
  width: 40%;
  text-align: center;
  line-height: 15px;
  color: white;
  font-size: 12px;
}
.showLayerchooseBoxItem {
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* color: ; */
}
.dashLine {
  stroke-dasharray: 5;
}
.leftTimeChooseBox {
  /* height: 100px; */
  width: 100%;
  background-color: #011f3dcb;
  box-shadow: 0 0 5px rgba(0, 191, 255, 0.5), 0 0 10px rgba(0, 191, 255, 0.3),
    0 0 15px rgba(0, 191, 255, 0.2);
  border: 1px solid #079dd5;
  position: absolute;
  top: 60px;
  /* left: 5px; */
  z-index: 999;
  border-radius: 10px;
  padding: 10px;
  color: #00bfff;
  font-weight: 600;
  /* color:  #01203f7e; */
}
.leaflet-image-layer {
  transition: opacity 1.8s ease-in-out !important;
}

.MyImghidden {
  opacity: 0;
}
.mytimeChooseBox {
  height: 30px;
  width: 100%;
  /* background-color: red; */
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
}
.mytimeChooseBox .btn {
  height: 30px;
  width: 40%;
  background-color: #409eff;
  /* margin-top: 10px; */
  text-align: center;
  color: white;
  line-height: 30px;
  border-radius: 5px;
}
</style>